import React from 'react';
import { motion } from 'framer-motion';
import { STATS } from '../lib/about-data';
import { cn } from '../../../shared/ui/kit/utils';

interface StatsSectionProps {
    className?: string;
}

export const StatsSection: React.FC<StatsSectionProps> = ({ className }) => {
    return (
        <div className={cn('py-8 px-4', className)}>
            <div className="max-w-4xl mx-auto">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {STATS.map((stat, index) => (
                        <motion.div
                            key={stat.label}
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.1, duration: 0.4 }}
                            className="text-center p-4 rounded-xl bg-gray-50 dark:bg-white/5 border border-black/[0.05] dark:border-white/[0.05]"
                        >
                            <div className="text-2xl font-bold text-gray-900 dark:text-gray-100 font-mono">
                                {stat.value}
                                <span className="text-sm text-blue-600 dark:text-blue-400 ml-0.5">
                                    {stat.suffix}
                                </span>
                            </div>
                            <div className="text-xs text-gray-500 dark:text-gray-500 mt-1">
                                {stat.label}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
};